// Single place for legal/business facts shown on public pages. Empty strings are hidden — nothing fake is rendered.
export const COMPANY = {
  legalName: "Swastik AI Labs Pvt Ltd",
  brand: "Vectra",
  domain: "vectra-ai.in",
  supportEmail: "support@vectra-ai.in",
  supportPhone: "+91 73597 77788",
  supportWhatsapp: "https://wa.me/917359777788",
  telegram: "https://t.me/+WO0s40101fFiMDll",
  cin: "",
  gstin: "",
  registeredAddress: "",
  businessHours: "Mon–Sat, 10:00–19:00 IST",
  grievanceOfficer: { name: "Akhilesh Mishra (Founder)", email: "support@vectra-ai.in", phone: "+91 73597 77788" },
  governingLawCity: "",
  retentionDays: 90,
  paymentRecordYears: 8,
  accountDeletionDays: 30,
  facebookUrl: "",
};

export const companyLine = () =>
  [COMPANY.legalName, COMPANY.cin && `CIN ${COMPANY.cin}`, COMPANY.gstin && `GSTIN ${COMPANY.gstin}`, COMPANY.registeredAddress, COMPANY.supportEmail].filter(Boolean).join(" · ");
